import React from 'react';
import { Phone, Leaf } from 'lucide-react';

const FixedHeader = ({ onNavigate, currentPage }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-[100] bg-black/95 backdrop-blur-md border-b border-white/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3 md:py-4">
          {/* Logo - text only */}
          <button
            onClick={() => onNavigate('home')}
            className="hover:opacity-80 transition-opacity"
          >
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-cyan-400 via-blue-500 to-pink-500 bg-clip-text text-transparent drop-shadow-2xl leading-tight whitespace-nowrap">
              Groupe Lavage Fenêtres
            </h1>
          </button>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-10 lg:space-x-12">
            {/* Eco Badge - First */}
            <div className="flex items-center space-x-1.5 bg-green-500/20 border-2 border-green-500/50 rounded-full px-3 py-1.5 backdrop-blur-sm whitespace-nowrap">
              <Leaf size={14} className="text-green-400" />
              <span className="text-xs font-bold text-green-400 uppercase tracking-wider">ÉCO</span>
            </div>
            
            <button
              onClick={() => {
                if (currentPage === 'lavage') {
                  const el = document.getElementById('gallery');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  onNavigate('lavage');
                  setTimeout(() => {
                    const el = document.getElementById('gallery');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 500);
                }
              }}
              className={`text-sm font-semibold transition-colors py-1 ${
                currentPage === 'lavage'
                  ? 'text-cyan-400'
                  : 'text-gray-400 hover:text-cyan-400'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => onNavigate('scellant')}
              className={`text-sm font-semibold transition-colors py-1 ${
                currentPage === 'scellant'
                  ? 'text-red-500'
                  : 'text-gray-400 hover:text-red-500'
              }`}
            >
              Scellant d'asphalte
            </button>
          </nav>

          {/* Contact Info */}
          <div className="flex items-center space-x-2 md:space-x-4">
            <a
              href="tel:8192002015"
              className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
            >
              <Phone size={16} className="md:hidden" />
              <Phone size={18} className="hidden md:block" />
              <span className="text-xs md:text-sm font-semibold">819.200.2015</span>
            </a>
            <button
              onClick={() => {
                if (currentPage === 'lavage') {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                } else if (currentPage === 'scellant') {
                  const element = document.getElementById('scellant-contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                } else {
                  onNavigate('lavage');
                  setTimeout(() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }, 500);
                }
              }}
              className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold shadow-lg transition-all transform hover:scale-105"
            >
              Contact
            </button>
          </div>
        </div>

        {/* Mobile Navigation - Removed for cleaner look */}
      </div>
    </header>
  );
};

export default FixedHeader;
